import React, { Suspense, lazy, useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ScoutingProfile from "../components/ScoutingProfile";

// Below-the-fold — lazy loaded to improve mobile Lighthouse score
const VideoGallery = lazy(() => import("../components/VideoGallery"));
const StatsDashboard = lazy(() => import("../components/StatsDashboard"));
const TacticalProfile = lazy(() => import("../components/TacticalProfile"));
const CareerTimeline = lazy(() => import("../components/CareerTimeline"));
const Achievements = lazy(() => import("../components/Achievements"));
const PhotoGallery = lazy(() => import("../components/PhotoGallery"));
const Dossier = lazy(() => import("../components/Dossier"));
const Contact = lazy(() => import("../components/Contact"));
const Footer = lazy(() => import("../components/Footer"));

const SectionFallback = () => (
  <div className="py-32 bg-marseille" aria-hidden="true" />
);

const HomePage = () => {
  // Lazy sections mount after hydration so server and first client render match.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <main className="relative bg-marseille text-white overflow-x-hidden">
      <Header />
      <Hero />
      <ScoutingProfile />
      {mounted ? (
      <Suspense fallback={<SectionFallback />}>
        <VideoGallery />
        <StatsDashboard />
        <TacticalProfile />
        <CareerTimeline />
        <Achievements />
        <PhotoGallery />
        <Dossier />
        <Contact />
        <Footer />
      </Suspense>
      ) : (
        <SectionFallback />
      )}
    </main>
  );
};

export default HomePage;
